import { createAsyncThunk } from '@reduxjs/toolkit'
import { PermissionsServerData } from '@lk/api'

import { ThunkApi } from '../index.d'

export const loadPermissions = createAsyncThunk<PermissionsServerData, void, ThunkApi>(
  '[Permissions] PERMISSIONS_LOAD',
  async (_, { extra, rejectWithValue }) => {
    const { success, data, error } = await extra.api.permission.get()

    if (success) {
      return data
    }

    return rejectWithValue(error)
  },
)
